package com.xtream.ui.ui.component.extension

import androidx.compose.runtime.Composable
import androidx.compose.ui.focus.FocusDirection
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.unit.LayoutDirection

@Composable
fun FocusDirection.Companion.endFocusDirection(): FocusDirection {
    return if (LocalLayoutDirection.current == LayoutDirection.Ltr) Right else Left
}

@Composable
fun FocusDirection.Companion.startFocusDirection(): FocusDirection {
    return if (LocalLayoutDirection.current == LayoutDirection.Ltr) Left else Right
}